import http from "../utils/axios";
// 获取批单列表接口
export const getCorrectionList = data => {
  return http({
    url: "/api/order/getCorrectionList", // 接口
    method: "post",
    data: data
  });
};
// 批单详情接口
export const getCorrection = data => {
  return http({
    url: "/api/order/getCorrection", // 接口
    method: "post",
    data: data
  });
};
// 批单上传批改资料接口
export const uploadCorrectionFile = data => {
  return http({
    url: "/api/order/uploadCorrectionFile", // 接口
    method: "post",
    data: data
  });
};
// 批单支付接口
export const correctionPay = data => {
  return http({
    url: "/api/order/correctionPay", // 接口
    method: "post",
    data: data
  });
};
// 获取批单人员列表接口
export const getCorrectionPerson = data => {
  return http({
    url: "/api/order/getCorrectionPerson", // 接口
    method: "post",
    data: data
  });
};
// 取消批单接口
export const cancelCorrection = data => {
  return http({
    url: "/api/order/cancelCorrection", // 接口
    method: "post",
    data: data
  });
};
// 保单、批单操作记录接口
export const getOperationLog = data => {
  return http({
    url: "/api/order/getOperationLog", // 接口
    method: "post",
    data: data
  });
};
